import dynamic from "next/dynamic";

export const ClientsMarquee = dynamic(() => import("./component"));
